import { DATA_REQUEST } from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    data: [],
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DATA_REQUEST.INITIATE:
        return { ...state, loader: true }
      case DATA_REQUEST.SUCCESS:
        return {
          ...state,
          error: null,
          data: action.payload.data,
          loader: false,
        }
      case DATA_REQUEST.ERROR:
        return { ...state, error: action.error }
      case DATA_REQUEST.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
